import { useSelector } from 'react-redux';
import { selectTenants } from '../../ui-frame/state/ui-frame.slice';
import Tenant from '../../core/models/Tenant';

export default function useGetGlobalSelectedTenants(): Tenant[] {
  const globalTenants = useSelector(selectTenants).filter(tenant => tenant.selected);
  const selectedAndSortedTenants: Tenant[] = [];

  const noTenantOption = globalTenants.find(tenant => tenant.uuid === 'items-without-tenant') as Tenant;

  globalTenants.forEach(tenant => {
    if (tenant.uuid !== 'items-without-tenant') {
      selectedAndSortedTenants.push(tenant);
    }
  });
  selectedAndSortedTenants.push(noTenantOption);

  return selectedAndSortedTenants.filter(t => t);
}
